/** 用户协议 */
<template>
  <div class="home protocol-home">
    <Layout
      type="HOME"
      pageTitle="供给方管理"
      titleSrc="/menu/homeIcon_black.png"
    >
      <BasiceLayout
        title="Bcode发放"
        class="bonus-code-layout"
        style="text-align: center"
      >
        <div class="display-flex-center margin-20">
          <div class="margin-right-20" style="min-width: 200px">操作账号</div>
          <el-input
            v-model="email"
            placeholder="输入要添加的账号"
            style="max-width: 200px"
          ></el-input>
        </div>
        <div class="display-flex-center margin-20">
          <div class="margin-right-20" style="min-width: 200px">发放Bcode类型</div>
          <el-select v-model="region" class="bonuscode-select-region" >
            <el-option default v-for="item in regionType" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="display-flex-center margin-20">
          <div class="margin-right-20" style="min-width: 200px">发放数量</div>
          <el-input
            v-model="count"
            placeholder="输入数量"
            style="max-width: 200px"
          ></el-input>
        </div>

        <div class="button send-bcode-button" @click="sendBcode">确定</div>
      </BasiceLayout>
    </Layout>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { log } from "util";
import { Message } from "element-ui";
import Layout from "@/components/CRM/Layout.vue";
import BasiceLayout from "@/components/Common/BasicLayout.vue";

export default {
  name: "home",
  data() {
    return {
      email: '',
      region: '',
      count: '',
      regionType: [
        {
          "value": 0,
          "label": "中国大陆"
        },
        {
          "value": 1,
          "label": "非中国大陆"
        },
        {	
          "value": 2,	
          "label": "中国大陆-计算任务专用"	
        }
      ]
    };
  },
  computed: mapState({}),
  components: {
    Layout,
    BasiceLayout,
  },
  methods: {
    ...mapActions(["setSendEmail"]),
    sendBcode() {
      let {
        email, 
        region, 
        count 
      } = this;


      if (!email || !count) {
        Message('参数为空')
      } else {
        this.setSendEmail({
          email,
          region,
          count
        }).then(res=> {
          let code = res.code;
          if (code === 200) {
            Message({
              type: 'success',
              message: '发放成功'
            })
          } else {
            Message({
              type: 'error',
              message: res.message
            })
          }
        })
      }
    }
  },
  created() {},
};
</script>

<style  lang="stylus">
.node-dial-content {
  width: 80%;
}

.crm-node-content {
  padding-top: 80px;
  height: auto;
  margin: 0 auto;
  background: #fff;
  padding: 20px;
  text-align: left;
}

.label-button {
  max-width: 100%;
}
</style>
